import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "view-card"
  }, [_c('div', {
    staticClass: "view-card-inner"
  }, [_c('div', {
    staticClass: "view-card-header view-card-header-pointer",
    on: {
      "click": function ($event) {
        return _vm.openMonitoringView(_vm.id, 'dashboard');
      }
    }
  }, [_c('div', {
    staticClass: "view-card-title view-card-drag-handle-disabled"
  }, [_c('p', {
    staticClass: "view-card-info"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.titleAccount')) + ": " + _vm._s(_vm.account) + "\n        ")]), _c('p', {
    staticClass: "view-card-name",
    attrs: {
      "data-cy": _vm.title
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "view-card-actions"
  }, [_c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm.canEdit ? _c(VIcon, {
    staticClass: "button_edit_monitoring_card mr-2",
    attrs: {
      "small": "",
      "color": _vm.color,
      "data-cy": "edit_btn"
    },
    on: {
      "click": function ($event) {
        return _vm.openMonitoringView(_vm.id, 'info');
      }
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n            fal fa-edit\n          ")]) : _vm._e(), _c(VIcon, {
    staticClass: "button_edit_monitoring_card mr-2",
    attrs: {
      "small": "",
      "color": _vm.color,
      "data-cy": "dashboard_btn"
    },
    on: {
      "click": function ($event) {
        return _vm.openMonitoringView(_vm.id, 'dashboard');
      }
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n            fal fa-eye\n          ")])], 1), _c(VIcon, {
    staticClass: "button_edit_monitoring_card mr-2",
    attrs: {
      "small": "",
      "color": _vm.color,
      "data-cy": "mapview_btn"
    },
    on: {
      "click": function ($event) {
        return _vm.openMapview(_vm.id);
      }
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          fal fa-map-marked-alt\n        ")]), _vm.canDelete ? _c(VIcon, {
    staticClass: "button_delete_monitoring_card",
    attrs: {
      "small": "",
      "color": _vm.color,
      "data-cy": "delete_btn"
    },
    on: {
      "click": _vm.handleDelete
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          fal fa-trash-alt\n        ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "view-card-content"
  }, [_c('div', {
    staticClass: "view-card-content-column"
  }, [_c('div', {
    staticClass: "view-card-content-column-header"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-sensor-on")]), _c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnVirtualDevices')))])], 1), _c('div', {
    staticClass: "view-card-content-column-content"
  }, [!(isNaN(_vm.devices) || _vm.devices === 0) ? _c('router-link', {
    class: {
      'non-empty': !(isNaN(_vm.devices) || _vm.devices === 0)
    },
    attrs: {
      "to": {
        name: 'VirtualDevicesList',
        query: {
          view: _vm.id,
          mode: 'devices'
        }
      },
      "data-cy": "number_link_devices"
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.devices) + "\n          ")]) : [_vm._v("\n            " + _vm._s(_vm.devices) + "\n          ")]], 2)]), _c('div', {
    staticClass: "view-card-content-column"
  }, [_c('div', {
    staticClass: "view-card-content-column-header"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-siren-on")]), _c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnErrors')))])], 1), _c('div', {
    staticClass: "view-card-content-column-content"
  }, [!(isNaN(_vm.errors) || _vm.errors === 0) ? _c('router-link', {
    class: {
      'danger--text': !(isNaN(_vm.errors) || _vm.errors === 0)
    },
    attrs: {
      "to": {
        name: 'VirtualDevicesList',
        query: {
          view: _vm.id,
          mode: 'errors'
        }
      },
      "data-cy": "number_link_errors"
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")]) : [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")]], 2)]), _c('div', {
    staticClass: "view-card-content-column"
  }, [_c('div', {
    staticClass: "view-card-content-column-header"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnWarnings')))])], 1), _c('div', {
    staticClass: "view-card-content-column-content"
  }, [!(isNaN(_vm.warnings) || _vm.warnings === 0) ? _c('router-link', {
    class: {
      'warning--text': !(isNaN(_vm.warnings) || _vm.warnings === 0)
    },
    attrs: {
      "to": {
        name: 'VirtualDevicesList',
        query: {
          view: _vm.id,
          mode: 'warnings'
        }
      },
      "data-cy": "number_link_warnings"
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.warnings) + "\n          ")]) : [_vm._v("\n            " + _vm._s(_vm.warnings) + "\n          ")]], 2)])])]), _c('div', {
    staticClass: "view-card-footer"
  }, _vm._l(_vm.tags, function (tag, idx) {
    return _c(VChip, {
      key: `chip-${idx}`,
      attrs: {
        "ripple": false,
        "small": ""
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.props')[tag.type] || tag.type) + ": \n      "), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(tag.text))])]);
  }), 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };